import MyIncidentViewer from "./myIncidentViewer";
import { connect } from "react-redux";
import { getIncidentList } from "../../../../redux/actions/incidentManagement/incidentList.action";
import { ReadNotification } from "../../../../redux/actions/notification/getEventNotificationList.action";
import { getAllMissingOneItsmCustomers } from "../../../../redux/actions/userManagement/getAllOneItsmServiceMissingCustomer.action";
import { getFilteredCustomers } from "../../../../redux/actions/userManagement/filterCustomers.action";
import { resetColumnFilters, setColumnFilters, setStatusFilter } from "../../../../redux/actions/filters/filter.action";

const mapStateToProps = (state) => {
  return {
    incidentList: state.incidentList,
    myRights : state.myRights.myRights,
    statusCount: state.incidentList.statusCount,
    notificationdata:state?.notifications?.moduleNotification?.data?.data?.INCIDENT,
    missingOneItsmCustomers:state?.missingOneItsmCustomers?.data,
    totalCount:state?.missingOneItsmCustomers?.totalcount,
    loadingMissingOneITSMCust:state?.missingOneItsmCustomers?.isLoading,
    filterCustomers:state.onboardingRequest.filterCustomers.customers,
    columnFilters: state?.filtersReducer?.columnFilters?.TICKETS || {},
    incidentActiveTab:state.incidentTab.incidentActiveTab,
    statusFilter: state?.filtersReducer?.status?.TICKETS 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getIncidentList: (next=null,status="",uniqueCustomerRefId="",orderBy="",searchKeyValue="")=>{
      return dispatch(getIncidentList(next,status,uniqueCustomerRefId,orderBy,searchKeyValue))
  },
    ReadNotification: (payload,id) => {
    return dispatch(ReadNotification(payload,id))
  },
  getAllMissingOneItsmCustomers: () => {
    return dispatch(getAllMissingOneItsmCustomers())
  },
  getFilteredCustomers: () => {
    return dispatch(getFilteredCustomers())
  },
  setColumnFilters: (screen, columnKey, options) =>{
      return dispatch(setColumnFilters(screen, columnKey, options))
  },
  setStatusFilter: (screen,data) => {
    return dispatch(setStatusFilter(screen, data))
  },
  resetColumnFilters: (screen) => {
    return dispatch(resetColumnFilters(screen))
  },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyIncidentViewer);
